const invertedMessages = {
  'No client credentials found.': 'Auth.EmptyState.NoClientCredentials',
};

export default invertedMessages;
